import React from 'react'
import * as prismic from '@prismicio/client'
import cms from 'libraries/front-end-core/decorators/cms'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import ContentPanelsContainer from 'redux/containers/pages/dashboard/ContentPanelsContainer'

const ContentPanelsWrapper = (props) => (
  <ResponseConsumer
    response={props.CMS_DATA}
    content={() => <ContentPanelsContainer {...props} />}
  />
)

const ContentPanelsCMSWrapper = ({ cmsCtx, aol, ...props }) => {
  const CmsComponent = React.useMemo(() => {
    const query = {
      predicates: [
        prismic.predicate.at('document.type', 'fc_homepage_content_panels'),
        prismic.predicate.at('my.fc_homepage_content_panels.area_of_law', aol)
      ]
    }

    return cms({ request: (cmsCtx) => cmsCtx.api.get(query), cacheKey: `fc_homepage_content_panels:${aol}` })(ContentPanelsWrapper)
  }, [aol])

  if (!cmsCtx) {
    return null
  }

  return <CmsComponent {...{ ...props, aol, cmsCtx }} />
}

export default ContentPanelsCMSWrapper
